import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Selection = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Selection' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,18 L8,18 L8,6 L5,6 L5,18 Z M12,2 L12,22 L12,2 Z M1,22 L23,22 L23,2 L1,2 L1,22 Z' />
  </StyledIcon>
);
